import { render, staticRenderFns } from "./QuotationDetails.vue?vue&type=template&id=1b217785&scoped=true"
import script from "./QuotationDetails.vue?vue&type=script&lang=js"
export * from "./QuotationDetails.vue?vue&type=script&lang=js"
import style0 from "./QuotationDetails.vue?vue&type=style&index=0&id=1b217785&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b217785",
  null
  
)

export default component.exports